module.exports = __webpack_public_path__ + "static/media/wire4.fa618d59.png";